var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "AAIntroContainer"
  }, [_c('div', {
    class: {
      'intro-container': true,
      'is-mobile-browser': _vm.isMobile && !_vm.isIOSApp,
      'is-playing-animation': _vm.isPlayingAnimation
    },
    style: {
      'background-image': _vm.isPlayingAnimation ? '' : _vm.backgroundImage
    }
  }, [!_vm.isPlayingAnimation ? _c('h1', {
    staticClass: "activity-title",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n      Assessment Accelerator\n    ")]) : _vm._e(), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPlayingAnimation,
      expression: "isPlayingAnimation"
    }],
    ref: "AAIntroVideoRef",
    attrs: {
      "id": "animation-video",
      "playsinline": "",
      "crossorigin": "anonymous"
    }
  }), _c('video-player-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPlayingAnimation,
      expression: "isPlayingAnimation"
    }],
    attrs: {
      "video": _vm.moduleVideo,
      "videoReference": this.$refs.AAIntroVideoRef
    }
  }), _c('portal', {
    attrs: {
      "to": "next-activity-button"
    }
  }, [_c('next-activity-button', {
    attrs: {
      "on-click": _vm.handleOnClick,
      "removeTabIndex": ""
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }